// extracted by mini-css-extract-plugin
export default {"productDescription":"laa-z","featuredDescription":"maa-z","description":"naa-z","more":"oaa-z","descriptionSku":"paa-z"};